export default function downloadInNewTab(url, params = {}, debug = false) {
  let filePath = url;

  const paramsEntries = Object.entries(params);
  if (paramsEntries.length) {
    let searchParams = [];

    for (const [key, value] of paramsEntries) {
      // default value is unnecessary for formConfig
      if (value === undefined || value === null) continue;
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          searchParams.push(`${key}[${index}]=${item}`);
        });
      } else {
        searchParams.push(`${key}=${value}`);
      }
    }

    filePath = `${url}?${searchParams.join('&')}`;
  }

  // NOTE: just for debug
  debug && console.log('download filePath', filePath);

  const link = document.createElement('a');
  link.setAttribute(
    'download',
    filePath.substring(filePath.lastIndexOf('/') + 1)
  );
  link.setAttribute('href', filePath);
  link.setAttribute('target', '_blank');
  link.click();
}
